import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Home, AlertCircle } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()
  
  // Auto redirect to home after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/')
    }, 5000)
    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center px-4">
      <motion.div 
        className="text-center max-w-md"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* 404 Icon */}
        <motion.div 
          className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6"
          animate={{ 
            scale: [1, 1.1, 1],
            rotate: [0, 5, -5, 0]
          }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <AlertCircle size={48} className="text-red-500" />
        </motion.div>
        
        {/* 404 Text */}
        <h1 className="text-6xl font-black text-gray-900 mb-2">404</h1>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          Halaman Tidak Ditemukan
        </h2>
        <p className="text-gray-600 mb-8">
          Maaf, halaman yang Anda cari tidak tersedia atau URL yang dimasukkan salah.
          Anda akan diarahkan ke halaman utama dalam beberapa detik.
        </p>
        
        {/* Back to Home Button */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-indigo-600 text-white rounded-full font-semibold shadow-lg hover:bg-indigo-700 transition-colors"
          >
            <Home size={20} />
            Kembali ke Beranda
          </Link>
        </motion.div>
        
        {/* Auto redirect message */}
        <p className="text-sm text-gray-400 mt-6">
          Mengalihkan otomatis dalam 5 detik...
        </p>
      </motion.div>
    </div>
  )
}
